export const NEW_NOTIFICATION = 'toastNotification/NEW'
export const RESET_NOTIFICATION = 'toastNotification/RESET'

export function showToastNotification(payload) {
  return {
    type: NEW_NOTIFICATION,
    payload
  }
}

export function resetToastNotification() {
  return {
    type: RESET_NOTIFICATION,
  }
}
